import { AlertService } from '@/services/alert.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-property-vcard',
    templateUrl: './property-vcard.component.html',
    styleUrls: ['./property-vcard.component.scss'],
    standalone: true
})
export class PropertyVCardComponent implements OnInit, OnDestroy {
  sub = new Subscription();

  constructor(private route: ActivatedRoute, private router: Router, private alertService: AlertService) {}

  ngOnInit(): void {
    this.sub = this.route.paramMap.subscribe((params) => {
      const eemoId = params.get('eemoId');
      if (!eemoId) {
        this.alertService.error('Paramètres invalides');
        return;
      } else {
        this.router.navigate(['/property/' + eemoId]);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }
}
